import React, { Component } from 'react';
import ListingProductTest from './ListingProductTest.js';
import InwardingApiHandlerTest from './../../InwardingApiHandlerTest.js';
import Radio from '@material-ui/core/Radio';
import Chip from '@material-ui/core/Chip';
import { Checkbox, CircularProgress } from '@material-ui/core';
import ImageUploader from './../../../../commons/ImageUploader.js';
import ErrorBox from './../../../../commons/ErrorBox.js';
import MobLoader from './../../../../commons/MobLoader.js';
import InputFloating from './../../../../commons/InputFloating.js';
import close from './../../../../assets/img/close.png';
import outerBoxImage from './../../../../assets/img/outer-box.png';
import innerBoxImage from './../../../../assets/img/inner-box.png';
import looseUnitsImg from './../../../../assets/img/loose-units.png';
import filled_tick from './../../../../assets/img/filled_tick.png';
import Dialog from '@material-ui/core/Dialog';
import Collapse from '@material-ui/core/Collapse';
import ExpDropSelector from './../../../../commons/ExpDropSelector.js';
import ProductInfoTest from './ProductInfoTest.js';
import ImageViewer2 from './../../../../commons/ImageViewer2';
import tick from './../../../../assets/img/not_completed.png';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';
import warn from './../../../../assets/img/warning.png';

const damageReasons = [
    {
        id: 'damaged_reason_3',
        reason_name: 'I will RTV Now',
    },
    {
        id: 'damaged_reason_1',
        reason_name: 'I will RTV Later',
    },
    {
        id: 'damaged_reason_2',
        reason_name: 'Sending for QC',
    },
];

const offerTypes = ['Within Pack/Kitted', 'Outside Pack/Unkitted'];

const offerDescriptions1 = [
    'Rs. Off (Rs.X OFF)',
    'Extra Grammage % (X% Extra)',
    'Extra Grammage (Xg FREE)',
    'Different product free inside (FREE X product worth Y Rs)',
];

const offerDescriptions2 = [
    'Same Product Free (Buy X get Y FREE)',
    'Different Product Free',
];

let selectedFacility;

const getSelectedFacilityData = JSON.parse(
    localStorage.getItem('selectedFacility')
);

if (getSelectedFacilityData) {
    const { facilityName } = getSelectedFacilityData;
    selectedFacility = facilityName;
}

export default class ProductDetailsTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            selectedProduct: null,
            vinv: null,
            selectedListing: null,
            allListings: [],
            showOtherOptions: false,
            showNewListingBox: false,
            listingHasOffer: false,
            showAddNewOffer: false,
            newMrp: '',
            totalItemValue: '',
            totalItemQty: '',
            expDays: 0,
            expTimeSpan: 'Days',
            expTimeSpanList: ['Days', 'Months', 'Years'],
            selectedOffer: null,
            showAddedToPalletBox: false,
            open: false,
            atleastOneActive: false,
            atleastOneInactive: false,
            offer: {
                backImage: null,
                frontImage: null,
                offerType: 'WITHIN_PACK',
                title: '',
                description: null,
            },
            inwardDetail: {
                qty: '',
                manufacturingDate: '',
                expiryDate: '',
                sellerBatchNumber: '',
                actualProductBarcode: '',
                nonDamagedQty: '',
                damagedQty: '',
                l1CaseSize: '',
                l2CaseSize: '',
                vendorInvoiceLineItemNumber: '',
                goodQty: 0,
                badQty: 0,
            },
            dateType: null,
            showAddDamagedQty: false,
            innerBoxQty: '',
            outerBoxQty: '',
            looseUnits: '',
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: '',
            caseSizeImageUrl: '',
            damageReasonType: '',
            innerBoxes: '',
            l1CaseSize: '',
            l2CaseSize: '',
            editCaseSizeMode: false,
            selectedOfferType: null,
            selectedOfferDescription1: null,
            selectedOfferDescription2: null,
            productsFromTitle: [],
            selectedFreebie: null,
            options1_1: '',
            options1_2: '',
            options1_3: '',
            options1_4: 'Freebie - ',
            options2_1: '',
            options2_2: '',
            frontImage: '',
            backImage: '',
            showProducts: false,
            loading1: false,
            loading: false,
            unitTypes: ['gram', 'kg', 'litre', 'ml', 'pieces'],
            measurementUnit: 'gram',
            //manufacturerBatchNumberAvailable: '',
            manufacturerBatchNumber: '',
            excessQuantityPresent: false,
            excessInwardReason: '',
            actionAfterVendorSuppliedMore: '',

            countingScreenTimeStarts: 0,
            underProcessQty: 0,
            batchNumberImageUrl: null,
            batchNumberIsNotPresent: false,
        };
        this.handleBatchNumberImageUploadResponse =
            this.handleBatchNumberImageUploadResponse.bind(this);
        this.handleBatchNumberRemoveImage =
            this.handleBatchNumberRemoveImage.bind(this);
        this.handleBatchNumberCompulsion =
            this.handleBatchNumberCompulsion.bind(this);
    }

    sendEvent = (eventName, eventData) => {
        const { selectedListing, selectedProduct, vinv, palletId } = this.state;
        //console.log(selectedProduct);
        if (!eventName || !eventData) {
            console.error('some parameter not passed in event');
            console.log(eventName);
            console.log(eventData);
            console.log(selectedListing);
            return;
        }
        let req = { ...eventData };
        if (selectedListing) {
            req['jpin'] = selectedListing.productInfoResponse
                ? selectedListing.productInfoResponse.jpin
                : null;
            req['product_name'] = selectedListing.productInfoResponse
                ? selectedListing.productInfoResponse.title
                : null;
        } else if (selectedProduct) {
            req['jpin'] = selectedProduct.productInfoResponse
                ? selectedProduct.productInfoResponse.jpin
                : null;
            req['product_name'] = selectedProduct.productInfoResponse
                ? selectedProduct.productInfoResponse.title
                : null;
        }

        req['inwarding_session_id'] = vinv;
        req['gric'] = palletId;
        sendEventToHevo(eventName, req);
    };

    closeError = () => {
        this.setState({ error: null });
    };

    closeAddedToPalletBox = () => {
        this.setState({ showAddedToPalletBox: false });
        this.props.history.push({
            pathname: '/Inwarding/AddPallet/' + this.state.vinv,
        });
    };

    setListingDataAndShowIt = (response) => {
        let x = false,
            y = false;
        if (response) {
            let listings = response.listingInformations;
            if (listings && listings.length > 0) {
                listings.forEach((i, index) => {
                    i['productInfoResponse'] = response.productInfoResponse;
                    if (i.status === 'INACTIVE') {
                        y = true;
                    } else {
                        //active, onboarding
                        x = true;
                    }
                });
            }
            this.setState({
                allListings: listings,
                showOtherOptions: true,
                atleastOneActive: x,
                atleastOneInactive: y,
            });
        }
    };

    getAllListingsForJPIN = () => {
        this.setState({ loading: true });
        let listingId = this.state.selectedProduct.listingId;
        InwardingApiHandlerTest.getAllListingsForJPIN(listingId)
            .then((resp) => {
                this.setListingDataAndShowIt(resp);
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    yesOrNoClicked = (option) => {
        let req = {
            is_same_listing: option === 'yes' ? true : false,
        };
        this.sendEvent('ON_CLICK_MRP_OFFER_MATCH_BUTTON', req);
    };

    getInitialInnerBoxes = (l1, l2) => {
        let innerBoxes = -1;
        if (l1 >= 0 && l2 === 0) {
            innerBoxes = 0;
        } else if (l1 > 0 && l2 > 0) {
            innerBoxes = l2 / l1;
        }

        return innerBoxes;
    };

    componentWillMount() {
        const {
            vinv,
            product,
            palletId,
            scannedBarcode,
            barcodeData,
            barcodeMatchStatus,
            receivedQuantity,
            underProcessQty,
        } = this.props.location.state;
        let expSt = product.productInfoResponse.expiryUnitString;
        let expTime = product.productInfoResponse.expiryPeriod;
        let expTimeSpan = this.state.expTimeSpan;
        let expDays = 0;
        if (expSt === 'Months' || expSt === 'Month') {
            expDays = parseFloat(expTime);
            expTimeSpan = 'Months';
        } else if (expSt === 'Years' || expSt === 'Year') {
            expDays = parseFloat(expTime);
            expTimeSpan = 'Years';
        } else {
            if (expTime) {
                expDays = parseFloat(expTime);
            }
        }

        //get initial case sizes, then calculate inital innerboxes
        let l1 = product.l1CaseSize,
            l2 = product.l2CaseSize;
        const innerBoxes = this.getInitialInnerBoxes(l1, l2);

        this.setState({
            selectedProduct: product,
            vinv: vinv,
            expDays: expDays,
            expTimeSpan: expTimeSpan,
            palletId: palletId,
            scannedBarcode: scannedBarcode,
            barcodeData: barcodeData,
            barcodeMatchStatus: barcodeMatchStatus,
            receivedQuantity: receivedQuantity,
            l1CaseSize: l1,
            l2CaseSize: l2,
            innerBoxes: innerBoxes,
            underProcessQty: underProcessQty,
        });
    }

    chipClicked = (l) => {
        this.setState({ selectedOffer: l });
    };

    deleteSelectedOffer = () => {
        this.setState({ selectedOffer: null });
    };

    newListingCreated = (listing) => {
        let o = listing.listingInformation;
        o.status = 'ACTIVE';
        o.productInfoResponse = listing.productInfoResponse;
        o.new = true;
        let all = this.state.allListings;
        all.unshift(o);
        this.setState({ allListings: all, showNewListingBox: false });
        document.getElementById('allData').scrollIntoView();
    };

    handleImageUploadResponse = (resp, type) => {
        let offer = { ...this.state.offer };
        offer[type] = resp;
        this.setState({ offer });
    };

    handleOfferTitle = (e) => {
        let offer = { ...this.state.offer };
        offer.title = e.target.value;
        this.setState({ offer });
    };

    isNewListingValidated = () => {
        const {
            listingHasOffer,
            offer,
            newMrp,
            selectedOffer,
            totalItemQty,
            totalItemValue,
        } = this.state;
        if (
            newMrp.length > 0 &&
            totalItemQty &&
            totalItemValue &&
            !listingHasOffer
        ) {
            return true;
        } else {
            if (newMrp && totalItemQty && totalItemValue && listingHasOffer) {
                if (offer.title && offer.frontImage && offer.backImage) {
                    return true;
                }
                if (selectedOffer) {
                    return true;
                }
            }
        }
        return false;
    };

    handleNewListingMrp = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleLineItemNumber = (e) => {
        this.sendEvent('ON_ENTER_INVOICE_LINE_ITEM_NUMBER', {
            invoice_line_item_no: Number(e.target.value),
        });
        let inwardDetail = { ...this.state.inwardDetail };
        inwardDetail.vendorInvoiceLineItemNumber = e.target.value;
        this.setState({ inwardDetail });
    };

    listingSelectionEvent = () => {
        const { selectedProduct, selectedListing } = this.state;
        let req = {
            po_listing: selectedProduct.listingId,
            selected_listing: selectedListing.listingId,
            status: selectedListing.status,
            mrp: selectedListing.mrp,
            offer_title: selectedListing.manufacturerOffer
                ? selectedListing.manufacturerOffer
                : '',
        };

        if (selectedListing.manufacturerOffer) {
            req.offer_title = selectedListing.manufacturerOffer.title;
            req.offer_description =
                selectedListing.manufacturerOffer.description;
        }

        this.sendEvent('ON_SELECT_INWARD_PRODUCT_LISTING', req);
    };

    productListingSelected = (product) => {
        let current_time = new Date().getTime();
        this.setState(
            {
                selectedListing: product,
                countingScreenTimeStarts: current_time,
            },
            () => {
                this.listingSelectionEvent();
                document.getElementById('allData').scrollIntoView();
            }
        );
    };

    productConfirmed = () => {
        this.productListingSelected(this.state.selectedProduct);
    };

    validateQuantity = (totalQty) => {
        // if offer like 'Buy X Get Y' OR 'Buy X Get productTitle Y' exists, then apply validations
        const { selectedListing } = this.state;

        if (
            selectedListing.manufacturerOffer &&
            selectedListing.manufacturerOffer.offerType === 'HAS_SEPARATE_ITEMS'
        ) {
            let arr = selectedListing.manufacturerOffer.title.split(' ');
            if (arr.length === 5) {
                // 'Buy X Get Y Free'
                let x = Number(arr[1]),
                    y = Number(arr[3]);
                if (totalQty % (x + y) !== 0) {
                    this.setState({
                        error: `Total quantity should be a multiple of ${x} + ${y}`,
                    });
                    return false;
                }
            } else {
                // 'Buy X Get productTitle Y Free'
                let x = Number(arr[1]);
                if (totalQty % x !== 0) {
                    this.setState({
                        error: `Total quantity should be a multiple of ${x}`,
                    });
                    return false;
                }
            }
        }

        return true;
    };

    tagToPallet = (req, countingScreenTimeStarts) => {
        const {
            selectedListing,
            actionAfterVendorSuppliedMore,
            excessInwardReason,
        } = this.state;
        let req2 = {};
        req2['good_qty'] = req.nonDamagedQty;
        req2['damaged_qty'] = req.damagedQty;
        req2['manufacturer_batch_number'] = req.manufacturerBatchNumber;
        req2['rtv_qty'] =
            excessInwardReason === 'rtv_now' ? req.rtvnowQty : req.rtvQty;
        req2['action_after_excess_qty'] = excessInwardReason;
        req2['mrp'] = selectedListing.mrp;
        this.sendEvent('ON_CLICK_TAG_TO_PALLET', req2);

        this.setState({ loading: true });
        req.rtvQty = excessInwardReason === 'rtv_now' ? 0 : req.rtvQty;
        if (excessInwardReason === 'rtv_now') {
            req.rtvNowQty = req.rtvnowQty;
        }

        InwardingApiHandlerTest.addToPallet(req)
            .then((resp) => {
                let time_taken_on_counting_screen = (
                    (new Date().getTime() - countingScreenTimeStarts) /
                    1000
                ).toFixed(0); // in seconds without decimal
                this.sendEvent('TIME_TAKEN_ON_COUNTING_SCREEN', {
                    duration: Number(time_taken_on_counting_screen),
                });

                this.setState({ showAddedToPalletBox: true, loading: false });
            })
            .catch((error) => {
                this.setState({ error: error.error.error, loading: false });
            });
    };

    addItemToPallet2 = (excessInward) => {
        const {
            inwardDetail,
            vinv,
            selectedListing,
            selectedProduct,
            palletId,
            scannedBarcode,
            barcodeMatchStatus,
            outerBoxQty,
            innerBoxQty,
            looseUnits,
            outerBoxQtyDamaged,
            innerBoxQtyDamaged,
            looseUnitsDamaged,
            caseSizeImageUrl,
            l1CaseSize,
            l2CaseSize,
            innerBoxes,
            countingScreenTimeStarts,
            damageReasonType,
            manufacturerBatchNumber,
            excessQtyFromApi1,
            actionAfterVendorSuppliedMore,
            excessInwardReason,
            barcodeData,
            batchNumberIsNotPresent,
            batchNumberImageUrl,
        } = this.state;

        let req = {};

        this.setState({ loading: true });

        try {
            if (selectedListing.manufacturerOffer) {
                let arr = selectedListing.manufacturerOffer.title.split(' ');
                req.freebieJpin = selectedListing.manufacturerOffer.offerJPIN;
                if (
                    selectedListing.manufacturerOffer.offerType ===
                    'HAS_SEPARATE_ITEMS'
                ) {
                    if (arr.length !== 5) {
                        //buy x get jpinTitle free
                        req.isOutsideProductFreebiePresent = true;
                        if (!req.freebieJpin) {
                            //if no offer jpin, send offer title in freebieJpin, catalog team will understand that it is not catalogued
                            req.freebieJpin =
                                selectedListing.manufacturerOffer.title;
                        }
                    } else {
                        //buy x get free
                        req.isSameProductFreebie = true;
                    }
                }
            }

            req.vendorInvoiceId = vinv;
            req.listingId = selectedListing.listingId;
            req.jpin = selectedListing.productInfoResponse.jpin;
            req.expectedListingId = selectedProduct.listingId;
            req.listingIdentificationType =
                selectedProduct.listingId === selectedListing.listingId
                    ? 'LISTING_MATCHED'
                    : selectedListing.new
                    ? 'LISTING_MISMATCHED_NEW'
                    : 'LISTING_MISMATCHED_EXISTING';
            req.expectedProductBarcode =
                selectedListing.productInfoResponse.ean;
            req.labelCodeMatchStatus = barcodeMatchStatus;
            req.scannedProductLabelCode = scannedBarcode;
            req.goodsReceivingContainerId = palletId;
            req.caseSizeImageUrl = caseSizeImageUrl ? caseSizeImageUrl : null;
            if (barcodeData) {
                req.capturedFrontSideImageUrl = barcodeData.frontImage;
                req.capturedLabelCodeImageUrl = barcodeData.barcodeImage;
            }

            let goodQty = 0,
                badQty = 0;
            let total = innerBoxes <= 0 ? l1CaseSize : l1CaseSize * innerBoxes;

            if (outerBoxQty || innerBoxQty || looseUnits) {
                goodQty =
                    total * outerBoxQty +
                    l1CaseSize * innerBoxQty +
                    1 * looseUnits;
            }

            if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
                badQty =
                    total * outerBoxQtyDamaged +
                    l1CaseSize * innerBoxQtyDamaged +
                    1 * looseUnitsDamaged;
            }

            req.nonDamagedQty = goodQty;
            req.damagedQty = badQty;
            req.qty = goodQty + badQty;
            req.rtvQty = 0;
            req.rtvNowQty = 0;

            if (damageReasonType === 'damaged_reason_1') {
                //'Inwarding now but have to return to vendor later'
                req.isRtv = true;
                req.rtvQty = badQty;
                req.damagedQty = 0;

                req.markParentWithoutFreebieForRTV = false;
            } else if (damageReasonType === 'damaged_reason_2') {
                //'Sending for QC (Quality check/ Liquidation)'
                req.isRtv = false;
                req.markParentWithoutFreebieForRTV = false;
            } else if (damageReasonType === 'damaged_reason_3') {
                req.rtvQty = 0;
                req.qty = goodQty;
                req.damagedQty = 0;
                req.rtvNowQty = badQty;
            }
            req.isPresentInPO = true;

            req.manufacturingDate = new Date(
                inwardDetail.manufacturingDate
            ).getTime();
            req.expiryDate = new Date(inwardDetail.expiryDate).getTime();

            req.vendorInvoiceLineItemNumber =
                inwardDetail.vendorInvoiceLineItemNumber;
            req.l1CaseSize = '' + l1CaseSize;
            req.l2CaseSize = '' + l2CaseSize;
            req.manufacturerBatchNumber = batchNumberIsNotPresent
                ? null
                : manufacturerBatchNumber;
            req.sellerBatchNumber = inwardDetail.sellerBatchNumber;
            req.actualProductBarcode = inwardDetail.actualProductBarcode;
            req.isMovingExcessQtyThanPOToRTV = false;
            req.manufacturerBatchNumberImgUrl = batchNumberImageUrl;

            //for app events

            if (!this.validateQuantity(goodQty + badQty)) {
                return;
            }

            if (excessInward) {
                if (req.damagedQty <= excessQtyFromApi1) {
                    req.damagedQty = 0;
                } else {
                    req.damagedQty -= excessQtyFromApi1;
                }

                if (excessInwardReason === 'rtv_later') {
                    req.isRtv = true;
                    req.rtvQty += excessQtyFromApi1;
                    req.isMovingExcessQtyThanPOToRTV = true;
                } else if (excessInwardReason === 'rtv_now') {
                    req.qty -= excessQtyFromApi1;
                    req.rtvnowQty = excessQtyFromApi1; // TODO check if rtvqty should include badqty or not
                }

                req.nonDamagedQty = req.qty - req.damagedQty - req.rtvQty;
                this.tagToPallet(req, countingScreenTimeStarts);
                return;
            }

            this.setState({ loading: true });
            InwardingApiHandlerTest.checkExcessQuantity(req)
                .then((resp) => {
                    if (resp > 0) {
                        //excess quantity
                        this.setState({
                            excessQuantityPresent: true,
                            excessQtyFromApi1: resp,
                        });
                        this.setState({ loading: false });
                    } else {
                        //no excess quantity
                        this.tagToPallet(req, countingScreenTimeStarts);
                    }
                })
                .catch((error) => {
                    this.setState({ error: error.error.error });
                    this.setState({ loading: false });
                });
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    };

    validateDamagedSection = () => {
        const {
            showAddDamagedQty,
            damageReasonType,
            //manufacturerBatchNumberAvailable,
            //manufacturerBatchNumber,
        } = this.state;

        if (showAddDamagedQty) {
            if (damageReasonType) {
                if (damageReasonType === 'damaged_reason_1') {
                    //if (manufacturerBatchNumberAvailable) {
                    //    if (manufacturerBatchNumberAvailable === 'yes') {
                    //        return manufacturerBatchNumber ? true : false;
                    //    } else {
                    //        return true;
                    //    }
                    //} else {
                    //    return false;
                    //}
                    return true;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        } else {
            return true;
        }
    };

    validateBatchNumber = () => {
        const { batchNumberIsNotPresent, manufacturerBatchNumber } = this.state;
        if (batchNumberIsNotPresent) return true;
        if (!batchNumberIsNotPresent && manufacturerBatchNumber) {
            return true;
        }
        return false;
    };

    // Compulsory fields and conditions required for form submission
    isItemAbleToAddInPallet2 = () => {
        const {
            selectedProduct,
            inwardDetail,
            outerBoxQty,
            innerBoxQty,
            looseUnits,
            caseSizeImageUrl,
            l1CaseSize,
            l2CaseSize,
            outerBoxQtyDamaged,
            innerBoxQtyDamaged,
            looseUnitsDamaged,
            showAddDamagedQty,
            damageReasonType,
            batchNumberImageUrl,
        } = this.state;

        let imageAddedAfterCaseSizeChange = true;
        if (
            (selectedProduct.l1CaseSize !== Number(l1CaseSize) ||
                selectedProduct.l2CaseSize !== Number(l2CaseSize)) &&
            !caseSizeImageUrl
        ) {
            imageAddedAfterCaseSizeChange = false;
        }

        if (
            (outerBoxQty ||
                innerBoxQty ||
                looseUnits ||
                outerBoxQtyDamaged ||
                innerBoxQtyDamaged ||
                looseUnitsDamaged) &&
            inwardDetail.manufacturingDate &&
            inwardDetail.expiryDate &&
            inwardDetail.manufacturingDate !== inwardDetail.expiryDate &&
            this.isManufacturingDateValid() &&
            this.isExpiryDateValid() &&
            Number(l1CaseSize) !== Number(l2CaseSize) &&
            inwardDetail.vendorInvoiceLineItemNumber &&
            this.isVendorInvoiceLineItemNumberValid() &&
            this.validateDamagedSection() &&
            imageAddedAfterCaseSizeChange &&
            this.validateBatchNumber() &&
            !!batchNumberImageUrl
        ) {
            return true;
        }

        return false;
    };

    selcetingListingFromOthers = (l) => {
        this.setState({ selectedListing: l });
    };

    showCreateNewListing = () => {
        this.sendEvent('ON_CLICK_CREATE_NEW_LISTING', {
            po_listing: this.state.selectedProduct.listingId,
        });
        this.setState({ showNewListingBox: true });
    };

    handleListinghasOffer = (e) => {
        let a = true;
        if (e.target.value === 'false') {
            a = false;
        }

        this.setState({ listingHasOffer: a }, () => {
            this.sendEvent('ON_CLICK_OFFER_BUTTON', {
                does_listing_have_offer: a,
            });
        });
    };

    activeAddNewOffer = () => {
        this.setState({ showAddNewOffer: true });
    };

    handleInwardChange = (e) => {
        const { dateType } = this.state;
        let { name, value } = e.target;
        let d = new Date(value).getTime();

        if (name === 'manufacturingDate') {
            this.sendEvent('ON_SELECT_MANUFACTURING_DATE', {
                manufacturing_date: d,
            });
        } else if (name === 'expiryDate') {
            if (dateType === 'date1') {
                this.sendEvent('ON_SELECT_EXPIRY_DATE', { expiry_date: d });
            } else if (dateType === 'date3') {
                this.sendEvent('ON_ENTER_BEST_BEFORE_DATE', {
                    best_before_date: d,
                });
            }
        }

        let inwardDetail = { ...this.state.inwardDetail };
        inwardDetail[name] = value;
        this.setState({ inwardDetail: inwardDetail }, function () {
            if (name === 'manufacturingDate') {
                this.changeExpiryDate();
            }
        });
    };

    changeExpiryDate = () => {
        const { expTimeSpan, expDays } = this.state;
        let eDays = expDays ? expDays : '0';
        let inwardDetail = { ...this.state.inwardDetail };
        if (inwardDetail.manufacturingDate) {
            let mDate = new Date(inwardDetail.manufacturingDate);
            let days = parseInt(eDays, 10);
            switch (expTimeSpan) {
                case 'Years':
                    mDate.setYear(mDate.getYear() + parseInt(days, 10) + 1900);
                    break;
                case 'Months':
                    mDate.setMonth(mDate.getMonth() + parseInt(days, 10));
                    break;
                default:
                    mDate.setDate(mDate.getDate() + parseInt(days, 10));
            }
            mDate = JSON.stringify(mDate);
            mDate = mDate.slice(1, 11);
            inwardDetail.expiryDate = mDate;
        }

        console.log(new Date(inwardDetail.expiryDate));
        this.setState({ inwardDetail: inwardDetail });
    };

    changeTotalQty = () => {
        let dam = Number(this.state.inwardDetail.damagedQty);
        let nonDam = Number(this.state.inwardDetail.nonDamagedQty);
        let total = nonDam ? (dam ? nonDam + dam : nonDam) : dam ? dam : 0;
        let inwardDetail = { ...this.state.inwardDetail };
        inwardDetail.qty = total;
        this.setState({ inwardDetail: inwardDetail });
    };

    handleExpTimeChange = (e) => {
        //console.log(e.target.value, typeof e.target.value);
        this.sendEvent('ON_ENTER_SHELF_LIFE', {
            shelf_life_count: Number(e.target.value),
        });
        this.setState({ expDays: e.target.value }, function () {
            this.changeExpiryDate();
        });
    };

    handelExpTimeSpanChange = (val) => {
        this.sendEvent('ON_SELECT_DDMMYY_SHELF_LIFE_OPTION', {
            shelf_life_type: val,
        });
        this.setState({ expTimeSpan: val }, function () {
            this.changeExpiryDate();
        });
    };

    isManufacturingDateValid = () => {
        const { inwardDetail } = this.state;
        if (inwardDetail.manufacturingDate) {
            let today = new Date().getTime();
            let mDate = new Date(inwardDetail.manufacturingDate).getTime();
            if (today < mDate) {
                return false;
            }
        }
        return true;
    };

    isVendorInvoiceLineItemNumberValid = () => {
        const lin = this.state.inwardDetail.vendorInvoiceLineItemNumber;
        if (lin === '' || (Number.isInteger(Number(lin)) && Number(lin) > 0)) {
            return true;
        }

        return false;
    };

    isExpiryDateValid = () => {
        const { inwardDetail } = this.state;
        if (inwardDetail.expiryDate) {
            let today = new Date().getTime();
            let mDate = new Date(inwardDetail.expiryDate).getTime();
            if (today > mDate) {
                return false;
            }
        }
        return true;
    };

    backButtonClicked = () => {
        this.sendEvent('ON_CLICK_COUNTING_BACK_BUTTON', {});
        //this.props.history.goBack();
        window.location.reload();
    };

    getHeaderBox = () => {
        const { selectedListing, showOtherOptions, showNewListingBox } =
            this.state;
        return (
            <div className="header-name-bar">
                <div className="row">
                    <div className="col-xs-1">
                        <div
                            className="visible-xs visible-sm"
                            style={{ lineHeight: '65px', fontSize: '25px' }}
                            onClick={this.backButtonClicked}
                        >
                            <i className="fas fa-arrow-left"></i>
                        </div>
                    </div>
                    <div className="col-xs-11">
                        <div className="header-page-name">
                            {!selectedListing && !showOtherOptions ? (
                                <div>Verify Product Details</div>
                            ) : (
                                <div>
                                    {!showNewListingBox ? (
                                        <div>
                                            {selectedListing ? (
                                                <div>Product Details</div>
                                            ) : (
                                                <div>Listings</div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div>Create New Listing</div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    mapEvents = (name, value) => {
        const { selectedProduct, l1CaseSize, l2CaseSize } = this.state;
        let l1 = selectedProduct.l1CaseSize,
            l2 = selectedProduct.l2CaseSize;
        const innerBoxes_initial = this.getInitialInnerBoxes(l1, l2); //initial
        const innerBoxes_current = this.getInitialInnerBoxes(
            l1CaseSize,
            l2CaseSize
        );

        switch (name) {
            case 'dateType':
                switch (value) {
                    case 'date1':
                        this.sendEvent(
                            'ON_SELECT_MANUFACTURING_EXPIRY_OPTION',
                            {}
                        );
                        break;
                    case 'date2':
                        this.sendEvent(
                            'ON_SELECT_MANUFACTURING_SHELF_LIFE_OPTION',
                            {}
                        );
                        break;
                    case 'date3':
                        this.sendEvent('ON_SELECT_BEST_BEFORE_OPTION', {});
                        break;
                    default:
                        console.error('random case');
                }
                break;
            case 'innerBoxes':
                this.sendEvent('ON_CLICK_INNER_BOXES_EDIT', {
                    inner_box_qty_before: Number(innerBoxes_initial),
                    inner_box_qty_after: Number(value),
                    loose_qty_before: l1,
                    loose_qty_after: Number(l1CaseSize),
                });
                break;
            case 'l1CaseSize':
                this.sendEvent('ON_CLICK_LOOSE_UNITS_EDIT', {
                    loose_qty_before: l1,
                    loose_qty_after: Number(value),
                    inner_box_qty_before: Number(innerBoxes_initial),
                    inner_box_qty_after: Number(innerBoxes_current),
                });
                break;
            case 'outerBoxQty':
                this.sendEvent('ON_ENTER_OUTER_BOX_QUANTITY', {
                    outer_qty: Number(value),
                });
                break;
            case 'innerBoxQty':
                this.sendEvent('ON_ENTER_INNER_BOX_QUANTITY', {
                    inner_qty: Number(value),
                });
                break;
            case 'looseUnits':
                this.sendEvent('ON_ENTER_LOOSE_UNITS_QUANTITY', {
                    loose_qty: Number(value),
                });
                break;
            case 'outerBoxQtyDamaged':
                this.sendEvent('ON_ENTER_OUTER_BOX_DAMAGED_QUANTITY', {
                    damaged_outer_qty: Number(value),
                });
                break;
            case 'innerBoxQtyDamaged':
                this.sendEvent('ON_ENTER_INNER_BOX_DAMAGED_QUANTITY', {
                    damaged_inner_qty: Number(value),
                });
                break;
            case 'looseUnitsDamaged':
                this.sendEvent('ON_ENTER_LOOSE_UNITS_DAMAGED_QUANTITY', {
                    damaged_loose_qty: Number(value),
                });
                break;
            case 'newMrp':
                this.sendEvent('ON_ENTER_NEW_LISTING_MRP', {
                    mrp: Number(value),
                });
                break;
            case 'options1_1':
                this.sendEvent('ON_ENTER_VALUE_RSOFF', {
                    rs_off: Number(value),
                });
                break;
            case 'options1_2':
                this.sendEvent('ON_ENTER_EXTRA_GRAMMAGE_PERCENT', {
                    grammage_percent: Number(value),
                });
                break;
            case 'options1_3':
                this.sendEvent('ON_ENTER_EXTRA_GRAMMAGE', {
                    grammage: Number(value),
                });
                break;
            case 'options2_1':
                this.sendEvent('ON_ENTER_BUY_PARENT_PRODUCT_QTY_OUTSIDE_PACK', {
                    parent_qty: Number(value),
                });
                break;
            case 'options2_2':
                this.sendEvent(
                    'ON_ENTER_GET_FREEBIE_PRODUCT_QTY_OUTSIDE_PACK',
                    { freebie_qty: Number(value) }
                );
                break;
            default:
                console.error('random case');
        }
    };

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        this.mapEvents(name, val);

        const greaterThanOrEqualToZero = [
            'outerBoxQty',
            'innerBoxQty',
            'looseUnits',
            'outerBoxQtyDamaged',
            'innerBoxQtyDamaged',
            'looseUnitsDamaged',
            'l1CaseSize',
            'innerBoxes',
            'newMrp',
        ];
        if (greaterThanOrEqualToZero.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val,
        });

        // logic to set l2 case size
        let l2 = 0;
        const { l1CaseSize, innerBoxes } = this.state;
        if (name === 'l1CaseSize') {
            if (innerBoxes <= 0) {
                l2 = 0;
            } else {
                l2 = innerBoxes * val;
            }
            this.setState({ l2CaseSize: l2 });
        } else if (name === 'innerBoxes') {
            l2 = val * l1CaseSize;
            if (Number(val) === 0) {
                this.setState({
                    l2CaseSize: l2,
                    innerBoxQty: '',
                    innerBoxQtyDamaged: '',
                });
            } else {
                this.setState({ l2CaseSize: l2 });
            }
        }
    };

    setMfgDateToday = () => {
        let inwardDetail = { ...this.state.inwardDetail };
        inwardDetail['manufacturingDate'] = new Date().getTime();
        this.setState({ inwardDetail: inwardDetail });
    };

    resetDamagedParameters = () => {
        const { showAddDamagedQty } = this.state;
        this.setState({
            showAddDamagedQty: !showAddDamagedQty,
            damageReasonType: '',
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: '',
            manufacturerBatchNumber: '',
            //manufacturerBatchNumberAvailable: '',
        });
    };

    makeDatesNull = () => {
        const { inwardDetail } = this.state;
        inwardDetail['manufacturingDate'] = '';
        inwardDetail['expiryDate'] = '';
        this.setState({ inwardDetail: inwardDetail });
    };

    resetCaseSize = () => {
        const { selectedProduct } = this.state;
        let l1 = selectedProduct.l1CaseSize,
            l2 = selectedProduct.l2CaseSize;
        const innerBoxes = this.getInitialInnerBoxes(l1, l2);

        this.setState({
            l1CaseSize: l1,
            l2CaseSize: l2,
            innerBoxes: innerBoxes,
            editCaseSizeMode: false,
            caseSizeImageUrl: '',
        });
    };

    dateFormatChange = (str) => {
        return (
            str.substring(8, 10) +
            '/' +
            str.substring(5, 7) +
            '/' +
            str.substring(0, 4)
        );
    };

    getShelfLife = (dateType) => {
        let mfg = this.state.inwardDetail.manufacturingDate;
        let exp = this.state.inwardDetail.expiryDate;
        if (dateType === 1 || dateType === 2) {
            if (
                mfg &&
                exp &&
                this.isManufacturingDateValid() &&
                this.isExpiryDateValid()
            ) {
                let m = new Date(mfg).getTime();
                let e = new Date(exp).getTime();
                let t = new Date().getTime();
                let s = (((e - t) / (e - m)) * 100).toFixed(1); //shelf_life_left
                return (
                    <div
                        style={{
                            border: '1px solid black',
                            margin: '8px 30px',
                            padding: '6px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            backgroundColor: s > 70 ? '#e4ffdd' : '#ffffcc',
                        }}
                    >
                        Note: Remaining shelf life is {s}%
                    </div>
                );
            } else {
                return null;
            }
        } else if (dateType === 3) {
            if (exp && this.isExpiryDateValid()) {
                let e = new Date(exp).getTime();
                let t = new Date().getTime();
                let s = ((e - t) / 86400000).toFixed(0);
                return (
                    <div
                        style={{
                            border: '1px solid black',
                            margin: '8px 30px',
                            padding: '6px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            backgroundColor: s > 100 ? '#e4ffdd' : '#ffffcc',
                        }}
                    >
                        Note: The product will expire in {s} days
                    </div>
                );
            } else {
                return null;
            }
        }
    };

    buyXgetYnote = () => {
        const { selectedListing } = this.state;
        if (
            selectedListing.manufacturerOffer &&
            selectedListing.manufacturerOffer.offerType === 'HAS_SEPARATE_ITEMS'
        ) {
            let arr = selectedListing.manufacturerOffer.title.split(' ');
            if (arr.length === 5) {
                // 'Buy X Get Y Free'
                return (
                    <div
                        style={{
                            backgroundColor: '#F7F4CB',
                            padding: '10px',
                            color: '#BD2E23',
                            marginTop: '8px',
                        }}
                    >
                        Note: Count parent and freebie together for this case
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    getGoodAndBadQuantity = () => {
        const {
            looseUnits,
            outerBoxQtyDamaged,
            innerBoxQtyDamaged,
            looseUnitsDamaged,
            outerBoxQty,
            innerBoxQty,
            l1CaseSize,
            l2CaseSize,
            innerBoxes,
        } = this.state;

        let goodQty = 0,
            badQty = 0;
        let total = innerBoxes <= 0 ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty =
                total * outerBoxQty + l1CaseSize * innerBoxQty + 1 * looseUnits;
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty =
                total * outerBoxQtyDamaged +
                l1CaseSize * innerBoxQtyDamaged +
                1 * looseUnitsDamaged;
        }

        return { goodQty, badQty };
    };

    handleBatchNumberImageUploadResponse(resp, type) {
        this.setState({ batchNumberImageUrl: resp });
    }

    handleBatchNumberRemoveImage(type) {
        this.setState({ batchNumberImageUrl: null });
    }

    handleBatchNumberCompulsion() {
        this.setState((prevState) => ({
            ...prevState,
            batchNumberIsNotPresent: !prevState.batchNumberIsNotPresent,
        }));
    }

    showEnterInwardingDetails2 = () => {
        const {
            selectedListing,
            inwardDetail,
            expDays,
            expTimeSpan,
            expTimeSpanList,
            barcodeData,
            dateType,
            looseUnits,
            showAddDamagedQty,
            outerBoxQtyDamaged,
            innerBoxQtyDamaged,
            looseUnitsDamaged,
            outerBoxQty,
            innerBoxQty,
            caseSizeImageUrl,
            selectedProduct,
            receivedQuantity,
            l1CaseSize,
            l2CaseSize,
            innerBoxes,
            editCaseSizeMode,
            manufacturerBatchNumber,
            //manufacturerBatchNumberAvailable,
            damageReasonType,
        } = this.state;

        let goodQty = 0,
            badQty = 0;
        let total = innerBoxes <= 0 ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty =
                total * outerBoxQty + l1CaseSize * innerBoxQty + 1 * looseUnits;
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty =
                total * outerBoxQtyDamaged +
                l1CaseSize * innerBoxQtyDamaged +
                1 * looseUnitsDamaged;
        }

        return (
            <div style={{ maxWidth: '700px', width: '100%' }}>
                <div
                    className={
                        this.isItemAbleToAddInPallet2()
                            ? 'lw-btn dtl-box'
                            : 'dtl-box'
                    }
                    style={{ padding: '10px 15px', scrollBehavior: 'smooth' }}
                >
                    <div>
                        <div>
                            <ProductInfoTest product={selectedListing} />
                        </div>

                        {this.buyXgetYnote()}

                        {barcodeData ? (
                            <div className="barcode-send-info top-twenty">
                                <img
                                    src={tick}
                                    className="small-image"
                                    alt="tick"
                                />{' '}
                                Product sent for Verification
                            </div>
                        ) : null}

                        <div className="top-twenty">
                            <InputFloating
                                type="number"
                                label="Vendor Invoice Line Item Number"
                                name="vendorInvoiceLineItemNumber"
                                value={inwardDetail.vendorInvoiceLineItemNumber}
                                onChange={this.handleLineItemNumber}
                            />
                            {!this.isVendorInvoiceLineItemNumberValid() ? (
                                <div className="error-text-fix">
                                    Please Enter Valid Line Item Number
                                </div>
                            ) : null}
                        </div>

                        <div
                            className="top-twenty"
                            style={{ maxWidth: '500px' }}
                        >
                            <div
                                className="v-imp-txt"
                                style={{
                                    marginBottom: '14px',
                                    fontWeight: '700',
                                }}
                            >
                                Case Size Details
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <div className="centralized">
                                    <div>
                                        <span>1</span>
                                        <img
                                            src={outerBoxImage}
                                            className="small-image"
                                            alt="L1"
                                        />
                                    </div>
                                    <div>Outer Box</div>
                                </div>
                                <div>has</div>
                                {innerBoxes !== -1 ? (
                                    <React.Fragment>
                                        <div className="centralized">
                                            <div>
                                                <input
                                                    type="number"
                                                    className="small-input2"
                                                    name="innerBoxes"
                                                    value={innerBoxes}
                                                    onChange={(e) => {
                                                        this.setNameToValue(e);
                                                    }}
                                                    disabled={!editCaseSizeMode}
                                                />
                                                <img
                                                    src={innerBoxImage}
                                                    className="small-image"
                                                    alt="L2"
                                                />
                                            </div>
                                            <div>Inner Box</div>
                                        </div>
                                        <div>with</div>
                                    </React.Fragment>
                                ) : null}
                                <div className="centralized">
                                    <div>
                                        <input
                                            type="number"
                                            id="looseUnits"
                                            className="small-input2"
                                            name="l1CaseSize"
                                            value={l1CaseSize}
                                            onChange={(e) => {
                                                this.setNameToValue(e);
                                            }}
                                            disabled={!editCaseSizeMode}
                                        />
                                        <img
                                            src={looseUnitsImg}
                                            className="small-image"
                                            alt="loose units"
                                        />
                                    </div>
                                    <div>Units</div>
                                </div>
                                <div>=</div>
                                <div className="centralized">
                                    <div>{total}</div>
                                    <div>Total Units</div>
                                </div>
                            </div>
                        </div>

                        {selectedProduct.l1CaseSize !== Number(l1CaseSize) ||
                        selectedProduct.l2CaseSize !== Number(l2CaseSize) ? (
                            <div>
                                <div
                                    style={{
                                        margin: '10px 0px',
                                        color: '#ee8f29',
                                        fontWeight: '500',
                                    }}
                                >
                                    You have edited the case sizes, Please add a
                                    photo proof of new case:
                                </div>
                                <div>
                                    {caseSizeImageUrl ? (
                                        <div style={{ margin: '10px' }}>
                                            <ImageViewer2
                                                src={caseSizeImageUrl}
                                                shouldRemove={true}
                                                onRemove={() => {
                                                    this.setState({
                                                        caseSizeImageUrl: '',
                                                    });
                                                }}
                                                alt="Img"
                                            />
                                        </div>
                                    ) : (
                                        <div>
                                            <ImageUploader
                                                url="inwarding/upload"
                                                type="caseSizeImageUrl"
                                                handleUploadResponse={(
                                                    resp,
                                                    type
                                                ) => {
                                                    this.setState({
                                                        caseSizeImageUrl: resp,
                                                    });
                                                    this.sendEvent(
                                                        'ON_CLICK_ADD_CASE_SIZE_PHOTO',
                                                        { image_url: resp }
                                                    );
                                                }}
                                                captureOnly={true}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{ marginTop: '10px', fontWeight: '600' }}
                            >
                                <span style={{ textDecoration: 'underline' }}>
                                    Note:
                                </span>{' '}
                                Case Sizes as per system data
                            </div>
                        )}

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                marginTop: '10px',
                            }}
                        >
                            {editCaseSizeMode ? (
                                <button
                                    className="btn btn-secondary"
                                    style={{ border: '1px solid' }}
                                    onClick={this.resetCaseSize}
                                >
                                    Reset Case Size
                                </button>
                            ) : (
                                <button
                                    className="btn btn-info"
                                    onClick={() => {
                                        this.setState(
                                            { editCaseSizeMode: true },
                                            () => {
                                                document
                                                    .getElementById(
                                                        'looseUnits'
                                                    )
                                                    .focus();
                                            }
                                        );
                                    }}
                                >
                                    Edit Case Size
                                </button>
                            )}
                        </div>

                        <div style={{ maxWidth: '600px' }}>
                            <div
                                className="v-imp-txt top-twenty"
                                style={{
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    color: 'green',
                                    border: '1px solid #BFBFBF',
                                    borderBottom: 'none',
                                    padding: '7px',
                                }}
                            >
                                {receivedQuantity} Units already received
                            </div>
                            <div
                                className="v-imp-txt"
                                style={{
                                    fontWeight: '700',
                                    textAlign: 'center',
                                    border: '1px solid #BFBFBF',
                                    borderBottom: 'none',
                                    padding: '7px',
                                }}
                            >
                                Good Quantity Received
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                    border: '1px solid #BFBFBF',
                                    borderBottom: 'none',
                                }}
                            >
                                <div className="centralized2">Outer Box</div>
                                <div className="centralized2">Inner Box</div>
                                <div className="centralized2">Loose Units</div>
                                <div className="centralized2">Total Units</div>
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                    border: '1px solid #BFBFBF',
                                }}
                            >
                                <div
                                    className="centralized2"
                                    style={{
                                        borderRight:
                                            '1px solid rgb(191,191,191)',
                                    }}
                                >
                                    <input
                                        type="number"
                                        className="small-input-cs"
                                        name="outerBoxQty"
                                        value={outerBoxQty}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                    />
                                </div>
                                <div
                                    className="centralized2"
                                    style={{
                                        borderRight:
                                            '1px solid rgb(191,191,191)',
                                    }}
                                >
                                    {Number(innerBoxes) > 0 ? (
                                        <input
                                            type="number"
                                            className="small-input-cs"
                                            name="innerBoxQty"
                                            value={innerBoxQty}
                                            onChange={(e) => {
                                                this.setNameToValue(e);
                                            }}
                                        />
                                    ) : (
                                        <div>-</div>
                                    )}
                                </div>
                                <div
                                    className="centralized2"
                                    style={{
                                        borderRight:
                                            '1px solid rgb(191,191,191)',
                                    }}
                                >
                                    <input
                                        type="number"
                                        className="small-input-cs"
                                        name="looseUnits"
                                        value={looseUnits}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                    />
                                </div>
                                <div className="centralized2">{goodQty}</div>
                            </div>
                        </div>

                        <React.Fragment>
                            <div className="top-twenty">
                                <div
                                    className="top-twenty"
                                    style={{ fontWeight: 700 }}
                                >
                                    Enter Manufacturer Batch Number
                                </div>

                                <div className="batchNumberCheckbox">
                                    <Checkbox
                                        value={
                                            this.state.batchNumberIsNotPresent
                                        }
                                        onChange={
                                            this.handleBatchNumberCompulsion
                                        }
                                    />
                                    <span>Batch number is not present</span>
                                </div>

                                <div
                                    style={{
                                        margin: '5px 0px 20px 0px',
                                    }}
                                >
                                    {this.state
                                        .batchNumberIsNotPresent ? null : (
                                        <span className="asterik">*</span>
                                    )}

                                    <InputFloating
                                        type="text"
                                        label="Batch Number"
                                        name="manufacturerBatchNumber"
                                        value={manufacturerBatchNumber}
                                        onChange={this.setNameToValue}
                                        disabled={
                                            this.state.batchNumberIsNotPresent
                                        }
                                    />
                                </div>

                                <div>
                                    <span className="asterik">*</span>
                                    {this.state.batchNumberImageUrl ? (
                                        <ImageViewer2
                                            src={this.state.batchNumberImageUrl}
                                            alt="batchNumberImage"
                                            style={{ width: '80%' }}
                                            type={'batchNumberImage'}
                                            shouldRemove={true}
                                            onRemove={
                                                this
                                                    .handleBatchNumberRemoveImage
                                            }
                                        />
                                    ) : (
                                        <ImageUploader
                                            url={'inwarding/upload'}
                                            type={'batchNumberImage'}
                                            handleUploadResponse={
                                                this
                                                    .handleBatchNumberImageUploadResponse
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        </React.Fragment>

                        {showAddDamagedQty ? (
                            <div style={{ maxWidth: '600px' }}>
                                <div
                                    className="v-imp-txt"
                                    style={{
                                        fontWeight: '700',
                                        textAlign: 'center',
                                        border: '1px solid #BFBFBF',
                                        borderBottom: 'none',
                                        padding: '7px',
                                    }}
                                >
                                    Damaged/RTV Quantity received
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        border: '1px solid #BFBFBF',
                                        borderBottom: 'none',
                                    }}
                                >
                                    <div className="centralized2">
                                        Outer Box
                                    </div>
                                    <div className="centralized2">
                                        Inner Box
                                    </div>
                                    <div className="centralized2">
                                        Loose Units
                                    </div>
                                    <div className="centralized2">
                                        Total Units
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        border: '1px solid #BFBFBF',
                                    }}
                                >
                                    <div
                                        className="centralized2"
                                        style={{
                                            borderRight:
                                                '1px solid rgb(191,191,191)',
                                        }}
                                    >
                                        <input
                                            type="number"
                                            className="small-input-cs"
                                            name="outerBoxQtyDamaged"
                                            value={outerBoxQtyDamaged}
                                            onChange={(e) => {
                                                this.setNameToValue(e);
                                            }}
                                        />
                                    </div>
                                    <div
                                        className="centralized2"
                                        style={{
                                            borderRight:
                                                '1px solid rgb(191,191,191)',
                                        }}
                                    >
                                        {Number(innerBoxes) > 0 ? (
                                            <input
                                                type="number"
                                                className="small-input-cs"
                                                name="innerBoxQtyDamaged"
                                                value={innerBoxQtyDamaged}
                                                onChange={(e) => {
                                                    this.setNameToValue(e);
                                                }}
                                            />
                                        ) : (
                                            <div>-</div>
                                        )}
                                    </div>
                                    <div
                                        className="centralized2"
                                        style={{
                                            borderRight:
                                                '1px solid rgb(191,191,191)',
                                        }}
                                    >
                                        <input
                                            type="number"
                                            className="small-input-cs"
                                            name="looseUnitsDamaged"
                                            value={looseUnitsDamaged}
                                            onChange={(e) => {
                                                this.setNameToValue(e);
                                            }}
                                        />
                                    </div>
                                    <div className="centralized2">{badQty}</div>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                        margin: '5px 0px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                    }}
                                >
                                    <div className="centralized2"></div>
                                    <div
                                        className="centralized2"
                                        style={{
                                            width: '50%',
                                            textAlign: 'end',
                                        }}
                                    >
                                        <div>Total quantity: </div>
                                        <div>(as per invoice)</div>
                                    </div>
                                    <div className="centralized2">
                                        {goodQty + badQty}
                                    </div>
                                </div>
                                <hr
                                    style={{
                                        borderColor: 'black',
                                        marginTop: '2px',
                                    }}
                                />

                                <div
                                    className="top-twenty"
                                    style={{ fontWeight: 700 }}
                                >
                                    Details about the Damaged/RTV quantity
                                </div>
                                {damageReasons.map((reason, index) => {
                                    return (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                margin: '10px',
                                            }}
                                            key={'dmgReason' + index}
                                        >
                                            <input
                                                type="radio"
                                                name="damageReasonType"
                                                id={reason.id}
                                                value={reason.id}
                                                onChange={this.setNameToValue}
                                                style={{ marginRight: '5px' }}
                                            />
                                            <label
                                                htmlFor={reason.id}
                                                style={{
                                                    textAlign: 'left',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {reason.reason_name}
                                            </label>
                                        </div>
                                    );
                                })}

                                {damageReasonType === 'damaged_reason_1' ? (
                                    <React.Fragment>
                                        <div className="top-twenty">
                                            {/*<div
                                                className='top-twenty'
                                                style={{ fontWeight: 700 }}
                                            >
                                                Enter Manufacturer Batch Number
                                            </div>*/}

                                            <div
                                                style={
                                                    {
                                                        //display: 'flex',
                                                        //alignItems: 'flex-start',
                                                        //margin: '10px',
                                                    }
                                                }
                                            >
                                                {/*<input
                                                    type='radio'
                                                    name='manufacturerBatchNumberAvailable'
                                                    id='barcode1'
                                                    value='yes'
                                                    onChange={() =>
                                                        this.setState({
                                                            manufacturerBatchNumberAvailable:
                                                                'yes',
                                                            manufacturerBatchNumber:
                                                                '',
                                                        })
                                                    }
                                                    style={{
                                                        marginRight: '5px',
                                                    }}
                                                />
                                                <label
                                                    htmlFor='barcode1'
                                                    style={{
                                                        textAlign: 'left',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Yes
                                                </label>*/}
                                                {/*<div
                                                    style={{
                                                        margin: '20px 20px 0px 10px',
                                                    }}
                                                >
                                                    <InputFloating
                                                        type='text'
                                                        label='Batch Number'
                                                        name='manufacturerBatchNumber'
                                                        value={
                                                            manufacturerBatchNumber
                                                        }
                                                        onChange={
                                                            this.setNameToValue
                                                        }
                                                    />
                                                </div>*/}
                                            </div>
                                            {/*{manufacturerBatchNumberAvailable ===
                                            'yes' ? (
                                                <div
                                                    style={{
                                                        margin: '10px 40px 0px 40px',
                                                    }}
                                                >
                                                    <InputFloating
                                                        type='text'
                                                        label='Manufacturer Batch Number'
                                                        name='manufacturerBatchNumber'
                                                        value={
                                                            manufacturerBatchNumber
                                                        }
                                                        onChange={
                                                            this.setNameToValue
                                                        }
                                                    />
                                                </div>
                                            ) : null}*/}

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    margin: '10px',
                                                }}
                                            >
                                                {/*<input
                                                    type='radio'
                                                    name='manufacturerBatchNumberAvailable'
                                                    id='barcode2'
                                                    value='no'
                                                    onChange={() =>
                                                        this.setState({
                                                            manufacturerBatchNumberAvailable:
                                                                'no',
                                                            manufacturerBatchNumber:
                                                                '',
                                                        })
                                                    }
                                                    style={{
                                                        marginRight: '5px',
                                                    }}
                                                />
                                                <label
                                                    htmlFor='barcode2'
                                                    style={{
                                                        textAlign: 'left',
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    Sugar Jpin, no batch number
                                                </label>*/}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ) : null}

                                <div
                                    className="top-ten"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <button
                                        className="btn btn-warning"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.resetDamagedParameters}
                                    >
                                        - No Damaged/RTV quantity
                                    </button>
                                </div>
                            </div>
                        ) : (
                            // <div className="top-twenty" style={{ textDecoration: 'underline', color: '#2891E1', cursor: 'pointer' }} onClick={() => { this.setState({ showAddDamagedQty: !showAddDamagedQty }) }}>
                            //     + Add Damaged Quantity (if any)
                            // </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <button
                                    className="btn btn-info top-twenty"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.setState({
                                            showAddDamagedQty:
                                                !showAddDamagedQty,
                                        });
                                        this.sendEvent(
                                            'ON_CLICK_ADD_DAMAGED_RECEIVED_QUANTITY',
                                            {}
                                        );
                                    }}
                                >
                                    + Add Damaged/RTV Quantity (if any)
                                </button>
                            </div>
                        )}

                        <div className="top-twenty" style={{ fontWeight: 700 }}>
                            What are the LOT details mentioned on the product?
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                name="dateType"
                                id="date1"
                                value="date1"
                                onChange={(e) => {
                                    this.makeDatesNull();
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="date1"
                                style={{ textAlign: 'left', fontWeight: 400 }}
                            >
                                Manufacturing Date and Expiry Date
                            </label>
                        </div>
                        {dateType === 'date1' ? (
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '300px',
                                            margin: '5px 30px',
                                        }}
                                    >
                                        <InputFloating
                                            type="date"
                                            label="Manufacturing Date"
                                            name="manufacturingDate"
                                            value={
                                                inwardDetail.manufacturingDate
                                            }
                                            onChange={this.handleInwardChange}
                                        />
                                        {!this.isManufacturingDateValid() ? (
                                            <div className="error-text-fix">
                                                Please Enter Valid Manufacturing
                                                Date
                                            </div>
                                        ) : null}
                                    </div>
                                    <div
                                        style={{
                                            width: '300px',
                                            margin: '5px 30px',
                                        }}
                                    >
                                        <InputFloating
                                            type="date"
                                            label="Expiry Date"
                                            name="expiryDate"
                                            value={inwardDetail.expiryDate}
                                            onChange={this.handleInwardChange}
                                        />
                                        {!this.isExpiryDateValid() ? (
                                            <div className="error-text-fix">
                                                Please Enter Valid Expiry Date
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                {this.getShelfLife(1)}
                            </div>
                        ) : null}

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                name="dateType"
                                id="date2"
                                value="date2"
                                onChange={(e) => {
                                    this.makeDatesNull();
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="date2"
                                style={{ textAlign: 'left', fontWeight: 400 }}
                            >
                                Manufacturing Date and Shelf Life
                            </label>
                        </div>
                        {dateType === 'date2' ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div
                                    style={{
                                        width: '300px',
                                        margin: '5px 30px 18px 30px',
                                    }}
                                >
                                    <InputFloating
                                        type="date"
                                        label="Manufacturing Date"
                                        name="manufacturingDate"
                                        value={inwardDetail.manufacturingDate}
                                        onChange={this.handleInwardChange}
                                    />
                                    {!this.isManufacturingDateValid() ? (
                                        <div className="error-text-fix">
                                            Please Enter Valid Manufacturing
                                            Date
                                        </div>
                                    ) : null}
                                </div>
                                <div
                                    style={{
                                        width: '300px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        margin: '5px 30px 18px 30px',
                                    }}
                                >
                                    <div style={{ width: '50%' }}>
                                        <InputFloating
                                            type="number"
                                            label="Time To Expiry"
                                            value={expDays}
                                            onChange={this.handleExpTimeChange}
                                        />
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <ExpDropSelector
                                            options={expTimeSpanList}
                                            selected={expTimeSpan}
                                            classes={{
                                                drop: 'invoice-type-drop',
                                            }}
                                            selctionChange={
                                                this.handelExpTimeSpanChange
                                            }
                                            type={'Expiry Time Span'}
                                        />
                                    </div>
                                </div>
                                {inwardDetail.manufacturingDate &&
                                inwardDetail.expiryDate &&
                                inwardDetail.expiryDate.length === 10 ? (
                                    <div>
                                        <div
                                            style={{
                                                width: '300px',
                                                margin: '5px 30px 18px 30px',
                                                opacity: '0.8',
                                            }}
                                        >
                                            [ Expiry Date:{' '}
                                            {this.dateFormatChange(
                                                inwardDetail.expiryDate
                                            )}{' '}
                                            ]
                                            {!this.isExpiryDateValid() ? (
                                                <div className="error-text-fix">
                                                    Invalid Expiry Date
                                                </div>
                                            ) : null}
                                        </div>
                                        {this.getShelfLife(2)}
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                name="dateType"
                                id="date3"
                                value="date3"
                                onChange={(e) => {
                                    this.setMfgDateToday();
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="date3"
                                style={{ textAlign: 'left', fontWeight: 400 }}
                            >
                                Best Before / Expiry Date
                            </label>
                        </div>
                        {dateType === 'date3' ? (
                            <div>
                                <div
                                    style={{
                                        width: '300px',
                                        margin: '5px 30px',
                                    }}
                                >
                                    <InputFloating
                                        type="date"
                                        label="Expiry Date"
                                        name="expiryDate"
                                        value={inwardDetail.expiryDate}
                                        onChange={this.handleInwardChange}
                                    />
                                    {!this.isExpiryDateValid() ? (
                                        <div className="error-text-fix">
                                            Please Enter Valid Expiry Date
                                        </div>
                                    ) : null}
                                </div>
                                {this.getShelfLife(3)}
                            </div>
                        ) : null}
                    </div>
                </div>
                {this.isItemAbleToAddInPallet2() ? (
                    <div
                        className="bottom-btn"
                        style={{ left: '0', right: '0' }}
                    >
                        <button
                            className="btn btn-big-fin"
                            onClick={() => this.addItemToPallet2(false)}
                            disabled={this.state.loading}
                        >
                            Tag to Pallet
                        </button>
                    </div>
                ) : null}
            </div>
        );
    };

    showOtherListingsOptions = () => {
        const { allListings, open, atleastOneActive, atleastOneInactive } =
            this.state;
        let x1 = 0,
            x2 = 0,
            y1 = 0,
            y2 = 0;
        return (
            <div>
                <div style={{ padding: '10px', marginBottom: '117px' }}>
                    {atleastOneActive ? (
                        <div
                            style={{
                                width: '100%',
                                padding: '15px 10px',
                                fontSize: '15px',
                                backgroundColor: '#fbfffb',
                            }}
                        >
                            Choose from below{' '}
                            <span style={{ color: '#03aa03' }}>Active</span>{' '}
                            Listings
                        </div>
                    ) : null}
                    <div>
                        {atleastOneActive ? (
                            <div
                                style={{
                                    width: '100%',
                                    paddingTop: '10px',
                                    fontSize: '15px',
                                }}
                            >
                                Listings without offer/freebie:{' '}
                            </div>
                        ) : null}
                        {allListings.map((a, index) => {
                            if (
                                a.status !== 'INACTIVE' &&
                                !a.manufacturerOffer
                            ) {
                                x1++;
                                return (
                                    <div key={index}>
                                        <ListingProductTest
                                            product={a}
                                            showQty={false}
                                            onClick={
                                                this.productListingSelected
                                            }
                                        />
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                        {atleastOneActive && x1 === 0 ? (
                            <div style={{ padding: '25px', color: '#BD2E23' }}>
                                <div style={{ textAlign: 'center' }}>
                                    No Listings available
                                </div>
                            </div>
                        ) : null}

                        {atleastOneActive ? (
                            <div
                                style={{
                                    width: '100%',
                                    paddingTop: '10px',
                                    fontSize: '15px',
                                }}
                            >
                                Listings with offer/freebie:{' '}
                            </div>
                        ) : null}
                        {allListings.map((a, index) => {
                            if (
                                a.status !== 'INACTIVE' &&
                                a.manufacturerOffer
                            ) {
                                x2++;
                                return (
                                    <div key={index}>
                                        <ListingProductTest
                                            product={a}
                                            showQty={false}
                                            onClick={
                                                this.productListingSelected
                                            }
                                        />
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                        {atleastOneActive && x2 === 0 ? (
                            <div style={{ padding: '25px', color: '#BD2E23' }}>
                                <div style={{ textAlign: 'center' }}>
                                    No Listings available
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {atleastOneInactive ? (
                        <div
                            style={{
                                width: '100%',
                                padding: '15px 10px',
                                fontSize: '15px',
                                marginTop: '20px',
                                backgroundColor: 'snow',
                            }}
                            onClick={() => {
                                this.setState({ open: !open });
                            }}
                        >
                            Choose from below{' '}
                            <span style={{ color: '#aa0303' }}>Inactive</span>{' '}
                            Listings{' '}
                            {open ? (
                                <i
                                    className="fas fa-chevron-up"
                                    style={{ marginLeft: '5px' }}
                                ></i>
                            ) : (
                                <i
                                    className="fas fa-chevron-down"
                                    style={{ marginLeft: '5px' }}
                                ></i>
                            )}
                        </div>
                    ) : null}
                    <Collapse in={open}>
                        <div>
                            {atleastOneInactive ? (
                                <div
                                    style={{
                                        width: '100%',
                                        paddingTop: '10px',
                                        fontSize: '15px',
                                    }}
                                >
                                    Listings with offer/freebie:{' '}
                                </div>
                            ) : null}
                            {allListings.map((a, index) => {
                                if (
                                    a.status === 'INACTIVE' &&
                                    !a.manufacturerOffer
                                ) {
                                    y1++;
                                    return (
                                        <div key={index}>
                                            <ListingProductTest
                                                product={a}
                                                showQty={false}
                                                onClick={
                                                    this.productListingSelected
                                                }
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                            {atleastOneInactive && y1 === 0 ? (
                                <div
                                    style={{
                                        padding: '25px',
                                        color: '#BD2E23',
                                    }}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        No Listings available
                                    </div>
                                </div>
                            ) : null}

                            {atleastOneInactive ? (
                                <div
                                    style={{
                                        width: '100%',
                                        paddingTop: '10px',
                                        fontSize: '15px',
                                    }}
                                >
                                    Listings with offer/freebie:{' '}
                                </div>
                            ) : null}
                            {allListings.map((a, index) => {
                                if (
                                    a.status === 'INACTIVE' &&
                                    a.manufacturerOffer
                                ) {
                                    y2++;
                                    return (
                                        <div key={index}>
                                            <ListingProductTest
                                                product={a}
                                                showQty={false}
                                                onClick={
                                                    this.productListingSelected
                                                }
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                            {atleastOneInactive && y2 === 0 ? (
                                <div
                                    style={{
                                        padding: '25px',
                                        color: '#BD2E23',
                                    }}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        No Listings available
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </Collapse>
                </div>

                <div className="btm-actn-br">
                    <div
                        style={{
                            textAlign: 'center',
                            marginBottom: '20px',
                            fontWeight: 'bold',
                        }}
                        className="v-imp-txt"
                    >
                        If the Listing don’t match
                    </div>
                    <div className="row">
                        <div className="col-xs-2"></div>
                        <div className="col-xs-8">
                            <button
                                className="btn btn-big-norm"
                                onClick={this.showCreateNewListing}
                            >
                                Create New Listing
                            </button>
                        </div>
                        <div className="col-xs-2"></div>
                    </div>
                </div>
            </div>
        );
    };

    getAllManufacturerOffer = () => {
        const { allListings, selectedOffer } = this.state;
        let a = [];
        allListings.forEach((l, index) => {
            if (l.manufacturerOffer !== null) {
                let itm =
                    selectedOffer && selectedOffer.listingId === l.listingId ? (
                        <div key={index} style={{ display: 'inline-block' }}>
                            <Chip
                                label={l.manufacturerOffer.title}
                                color="primary"
                                variant="default"
                                onDelete={this.deleteSelectedOffer}
                                classes={{
                                    root: 'chipRootBlue top-ten',
                                    colorPrimary: 'chipColorWhite',
                                    deleteIcon: 'chipColorWhite',
                                    label: 'brokenText',
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            key={index}
                            onClick={() => {
                                this.chipClicked(l);
                            }}
                            style={{ display: 'inline-block' }}
                        >
                            <Chip
                                label={l.manufacturerOffer.title}
                                clickable={true}
                                color="primary"
                                variant="outlined"
                                classes={{
                                    root: 'chipRootWhite top-ten',
                                    colorPrimary: 'chipColorBlue',
                                    deleteIcon: 'chipColorBlue',
                                    label: 'brokenText',
                                }}
                            />
                        </div>
                    );
                a.push(itm);
            }
        });
        return a;
    };

    parentFreebieUI = () => {
        const { options2_1, options2_2 } = this.state;
        return (
            <div>
                <div className="top-twenty justCent">
                    <div style={{ width: '75%' }}>
                        <InputFloating
                            type="number"
                            label="Buy Parent Product"
                            name="options2_1"
                            value={options2_1}
                            onChange={(e) => {
                                this.setNameToValue(e);
                            }}
                        />
                    </div>
                    <div className="symbolBox" style={{ width: '25%' }}>
                        X Units
                    </div>
                </div>
                <div className="top-twenty justCent">
                    <div style={{ width: '75%' }}>
                        <InputFloating
                            type="number"
                            label="Get Freebie"
                            name="options2_2"
                            value={options2_2}
                            onChange={(e) => {
                                this.setNameToValue(e);
                            }}
                        />
                    </div>
                    <div className="symbolBox" style={{ width: '25%' }}>
                        Y Units
                    </div>
                </div>
            </div>
        );
    };

    searchProductFromTitle = (title) => {
        this.setState({ loading1: true, options1_4: title });
        InwardingApiHandlerTest.searchProductFromTitle(title)
            .then((data) => {
                this.setState({
                    productsFromTitle: data.productSearchResponseList,
                    showProducts: true,
                });
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading1: false });
            });
    };

    validateTitle = (title) => {
        if (
            title &&
            title.length > 10 &&
            title.substring(0, 10).toLowerCase() === 'freebie - '
        ) {
            return true;
        }

        return false;
    };

    inputTitleChanged = (e, num) => {
        let title = e.target.value;

        //within pack, no title search
        if (num === 1) {
            this.sendEvent('ON_ENTER_GET_FREEBIE_PRODUCT_WITHIN_PACK', {
                product_search_title: title,
            });
            this.setState({ options1_4: title });
            return;
        }

        //outside pack, display products according tot title and Freebie - should be prefix
        if (!this.validateTitle(title)) {
            title = 'Freebie - ';
        }

        this.sendEvent('ON_ENTER_GET_FREEBIE_PRODUCT_OUTSIDE_PACK_TITLE', {
            product_search_title: title,
        });
        this.searchProductFromTitle(title);
    };

    setOfferType = (val) => {
        if (val === 'Within Pack/Kitted') {
            this.setState({
                selectedOfferType: val,
                options1_4: '',
                productsFromTitle: [],
            });
        } else {
            this.setState({ selectedOfferType: val, options1_4: 'Freebie - ' });
        }
    };

    productSearchUI = (num) => {
        const { options1_4, productsFromTitle, loading1, showProducts } =
            this.state;

        return (
            <div className="top-twenty">
                <InputFloating
                    type="text"
                    label="Free Product Name"
                    name="options1_4"
                    value={options1_4}
                    onChange={(e) => {
                        this.inputTitleChanged(e, num);
                    }}
                />

                {loading1 ? (
                    <div
                        className="product-search-dropdown"
                        style={{
                            display: 'block',
                            textAlign: 'center',
                            padding: '10px',
                            height: '50px',
                        }}
                    >
                        <CircularProgress
                            style={{ color: '#000' }}
                            size={23}
                            thickness={3}
                        />
                    </div>
                ) : (
                    <React.Fragment>
                        {productsFromTitle.length > 0 && showProducts ? (
                            <ul
                                className="product-search-dropdown"
                                style={{ display: 'block' }}
                            >
                                {productsFromTitle.map((product) => {
                                    return (
                                        <li
                                            className={'dropdown-data-rec'}
                                            key={product.jpin}
                                            onClick={() => {
                                                this.setState({
                                                    options1_4: product.title,
                                                    offerJpin: product.jpin,
                                                    selectedFreebie: product,
                                                    showProducts: false,
                                                });
                                            }}
                                        >
                                            <div className="dropdown-data-rec-inner">
                                                <div className="row">
                                                    <div
                                                        className="col-xs-3"
                                                        style={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                product.imageUrl
                                                            }
                                                            style={{
                                                                maxWidth:
                                                                    '100%',
                                                                maxHeight:
                                                                    '40px',
                                                            }}
                                                            alt="product"
                                                        />
                                                    </div>
                                                    <div className="col-xs-9">
                                                        {product.title}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : null}
                    </React.Fragment>
                )}
            </div>
        );
    };

    isNewListingValidated2 = () => {
        const { listingHasOffer, newMrp, frontImage, backImage } = this.state;

        const offerTitle = this.getOfferTitle();

        // && frontImage && backImage
        if (
            Number(newMrp) > 0 &&
            (!listingHasOffer ||
                (listingHasOffer && offerTitle && frontImage && backImage))
        ) {
            return true;
        }

        return false;
    };

    /**
     *  For the more inward dialog box, we show two options
     *  The user has to select appropriate options, to activate proceed button
     */
    validateProceed = () => {
        const { excessInwardReason, actionAfterVendorSuppliedMore } =
            this.state;
        if (!excessInwardReason) {
            return false;
        }

        return true;
    };

    proceedClicked = () => {
        const { excessInwardReason } = this.state;
        if (excessInwardReason === 'edit') {
            //remove dialog box, so user can edit the qty
            this.setState({
                excessQuantityPresent: false,
                excessInwardReason: '',
                actionAfterVendorSuppliedMore: '',
            });
        } else {
            //the true flag signifies to send goodsReceivedItemInwardReasonCode in the gri request
            this.addItemToPallet2(true);
        }
    };

    getOfferTitle = () => {
        const {
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            options1_1,
            options1_2,
            options1_3,
            options1_4,
            options2_1,
            options2_2,
            measurementUnit,
        } = this.state;
        let offerTitle = '',
            valueValidation = false;

        switch (selectedOfferType) {
            case 'Within Pack/Kitted':
                switch (selectedOfferDescription1) {
                    case 'Rs. Off (Rs.X OFF)':
                        valueValidation = Number(options1_1) > 0;
                        offerTitle = `Rs.${options1_1} Off`;
                        break;
                    case 'Extra Grammage % (X% Extra)':
                        valueValidation = Number(options1_2) > 0;
                        offerTitle = `${options1_2}% Extra`;
                        break;
                    case 'Extra Grammage (Xg FREE)':
                        valueValidation = Number(options1_3) > 0;
                        offerTitle = `${options1_3} ${measurementUnit} Free`;
                        break;
                    case 'Different product free inside (FREE X product worth Y Rs)':
                        valueValidation = options1_4 && options1_4.length > 0;
                        offerTitle = `${options1_4} Free Inside`;
                        break;
                    default:
                        console.log('Unknown case');
                }
                break;
            case 'Outside Pack/Unkitted':
                switch (selectedOfferDescription2) {
                    case 'Same Product Free (Buy X get Y FREE)':
                        valueValidation =
                            Number(options2_1) > 0 && Number(options2_2) > 0;
                        offerTitle = `Buy ${options2_1} Get ${options2_2} Free`;
                        break;
                    case 'Different Product Free':
                        valueValidation =
                            Number(options2_1) > 0 &&
                            Number(options2_2) > 0 &&
                            options1_4 &&
                            options1_4.length > 0;
                        offerTitle = `Buy ${options2_1} Get ${options2_2} ${options1_4} Free`;
                        break;
                    default:
                        console.log('Unknown case');
                }
                break;
            default:
                console.log('Unknown case');
        }

        if (valueValidation) {
            return offerTitle;
        } else {
            return '';
        }
    };

    createNewListing2 = () => {
        const {
            listingHasOffer,
            newMrp,
            selectedProduct,
            vinv,
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            frontImage,
            backImage,
            offerJpin,
            measurementUnit,
        } = this.state;
        var mOffer = {};
        mOffer.offerJPIN = offerJpin ? offerJpin : null;
        let offerTypeDescription = '',
            mUnit = '';

        if (listingHasOffer) {
            mOffer = {
                ...mOffer,
                title: this.getOfferTitle(),
                offerType: selectedOfferType,
                frontImage: frontImage,
                backImage: backImage,
                description: null,
            };
            if (selectedOfferType === 'Outside Pack/Unkitted') {
                mOffer.offerType = 'HAS_SEPARATE_ITEMS';
                offerTypeDescription = selectedOfferDescription2;
            } else if (selectedOfferType === 'Within Pack/Kitted') {
                mOffer.offerType = 'WITHIN_PACK';
                offerTypeDescription = selectedOfferDescription1;
                if (selectedOfferDescription1 === 'Extra Grammage (Xg FREE)') {
                    mUnit = measurementUnit;
                }
            }
        }

        let req = {
            vendorInvoiceId: vinv,
            manufacturerOfferRequest: listingHasOffer ? mOffer : null,
            mrp: newMrp,
            jpin: selectedProduct.productInfoResponse.jpin,
        };

        let eventRequest = {
            mrp: Number(newMrp),
            measurement_unit: mUnit ? mUnit : null,
            listing_has_offer: listingHasOffer,
            offer_title_generated: mOffer.title ? mOffer.title : null,
            offer_type: selectedOfferType ? selectedOfferType : null,
            offer_type_description: offerTypeDescription,
            front_image: frontImage,
            back_image: backImage,
        };
        //console.log(req);
        this.sendEvent('ON_CREATE_NEW_LISTING', eventRequest);

        this.setState({ loading: true });
        InwardingApiHandlerTest.createNewListing(req)
            .then((resp) => {
                this.newListingCreated(resp);
            })
            .catch((error) => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    createNewListingFlow2 = () => {
        const {
            selectedProduct,
            listingHasOffer,
            newMrp,
            selectedOfferType,
            selectedOfferDescription1,
            selectedOfferDescription2,
            options1_1,
            options1_2,
            options1_3,
            frontImage,
            backImage,
            unitTypes,
            measurementUnit,
        } = this.state;
        const offerTitle = this.getOfferTitle();
        console.log(selectedProduct);
        return (
            <div>
                <div style={{ padding: '10px', marginBottom: '80px' }}>
                    <div
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #dfdfdf',
                            padding: '10px',
                        }}
                    >
                        <div className="row">
                            <div
                                className="col-xs-4"
                                style={{ textAlign: 'center' }}
                            >
                                <img
                                    src={
                                        selectedProduct.productInfoResponse
                                            .imageUrls[0].thumbnail
                                    }
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100px',
                                    }}
                                    alt="product"
                                />
                            </div>
                            <div className="col-xs-8 no-left-padding">
                                <div className="v-imp-txt">
                                    {selectedProduct.productInfoResponse.title}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #dfdfdf',
                            padding: '10px',
                            marginTop: '10px',
                        }}
                    >
                        <div
                            className="v-imp-txt"
                            style={{ fontWeight: 'bold' }}
                        >
                            Enter Details
                        </div>

                        <div className="top-twenty input-group">
                            <span className="input-group-addon">₹</span>
                            <InputFloating
                                type="number"
                                label="MRP"
                                value={newMrp}
                                name="newMrp"
                                onChange={this.setNameToValue}
                            />
                        </div>

                        <div
                            className="top-ten"
                            style={{ border: '1px solid #dfdfdf' }}
                        ></div>

                        <div
                            className="top-ten v-imp-txt"
                            style={{ fontWeight: 'bold' }}
                        >
                            Does this product have an offer/freebie?
                        </div>
                        <div className="row" style={{ fontSize: '18px' }}>
                            <div className="col-xs-6">
                                <Radio
                                    checked={listingHasOffer}
                                    onChange={this.handleListinghasOffer}
                                    value="true"
                                    name="radio-button-demo"
                                    aria-label="A"
                                    color="default"
                                    classes={{ checked: 'blue' }}
                                />{' '}
                                <span
                                    style={
                                        listingHasOffer
                                            ? { color: '#1394f6' }
                                            : {}
                                    }
                                >
                                    Yes
                                </span>
                            </div>
                            <div className="col-xs-6">
                                <Radio
                                    checked={!listingHasOffer}
                                    onChange={this.handleListinghasOffer}
                                    value="false"
                                    name="radio-button-demo"
                                    aria-label="A"
                                    color="default"
                                />{' '}
                                No
                            </div>
                        </div>

                        {listingHasOffer ? (
                            <div style={{ marginTop: '5px' }}>
                                <ExpDropSelector
                                    options={offerTypes}
                                    selected={selectedOfferType}
                                    classes={{ drop: 'invoice-type-drop' }}
                                    selctionChange={(val) => {
                                        this.setOfferType(val);
                                        this.sendEvent(
                                            'ON_SELECT_SELECT_OFFER_TYPE',
                                            { offer_type: val }
                                        );
                                    }}
                                    type={'Offer Type'}
                                />
                                {selectedOfferType === 'Within Pack/Kitted' ? (
                                    <div className="top-twenty">
                                        <ExpDropSelector
                                            options={offerDescriptions1}
                                            selected={selectedOfferDescription1}
                                            classes={{
                                                drop: 'invoice-type-drop',
                                            }}
                                            selctionChange={(val) => {
                                                this.setState({
                                                    selectedOfferDescription1:
                                                        val,
                                                });
                                                this.sendEvent(
                                                    'ON_SELECT_OFFER_DESCRIPTION',
                                                    { offer_description: val }
                                                );
                                            }}
                                            type={'Offer Description'}
                                        />
                                        {selectedOfferDescription1 ===
                                        'Rs. Off (Rs.X OFF)' ? (
                                            <div className="top-twenty justCent">
                                                <div
                                                    className="symbolBox"
                                                    style={{ width: '15%' }}
                                                >
                                                    ₹
                                                </div>
                                                <div style={{ width: '85%' }}>
                                                    <InputFloating
                                                        type="number"
                                                        label="Value of Rs. Off"
                                                        name="options1_1"
                                                        value={options1_1}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Extra Grammage % (X% Extra)' ? (
                                            <div className="top-twenty justCent">
                                                <div style={{ width: '85%' }}>
                                                    <InputFloating
                                                        type="number"
                                                        label="Extra Weight % value"
                                                        name="options1_2"
                                                        value={options1_2}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    className="symbolBox"
                                                    style={{ width: '15%' }}
                                                >
                                                    %
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Extra Grammage (Xg FREE)' ? (
                                            <div
                                                className="top-twenty"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <div style={{ width: '70%' }}>
                                                    <InputFloating
                                                        type="number"
                                                        label="Extra Weight value"
                                                        name="options1_3"
                                                        value={options1_3}
                                                        onChange={(e) => {
                                                            this.setNameToValue(
                                                                e
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ width: '30%' }}>
                                                    <ExpDropSelector
                                                        options={unitTypes}
                                                        selected={
                                                            measurementUnit
                                                        }
                                                        classes={{
                                                            drop: 'invoice-type-drop',
                                                        }}
                                                        selctionChange={(
                                                            val
                                                        ) => {
                                                            this.setState({
                                                                measurementUnit:
                                                                    val,
                                                            });
                                                            this.sendEvent(
                                                                'ON_ENTER_EXTRA_GRAMMAGE_UNIT',
                                                                {
                                                                    measurement_unit:
                                                                        val,
                                                                }
                                                            );
                                                        }}
                                                        type={'Unit'}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription1 ===
                                        'Different product free inside (FREE X product worth Y Rs)' ? (
                                            <div className="top-twenty">
                                                {this.productSearchUI(1)}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                                {selectedOfferType ===
                                'Outside Pack/Unkitted' ? (
                                    <div className="top-twenty">
                                        <ExpDropSelector
                                            options={offerDescriptions2}
                                            selected={selectedOfferDescription2}
                                            classes={{
                                                drop: 'invoice-type-drop',
                                            }}
                                            selctionChange={(val) => {
                                                this.setState({
                                                    selectedOfferDescription2:
                                                        val,
                                                });
                                            }}
                                            type={'Offer Description'}
                                        />
                                        {selectedOfferDescription2 ===
                                        'Same Product Free (Buy X get Y FREE)' ? (
                                            <div className="top-twenty">
                                                {this.parentFreebieUI()}
                                            </div>
                                        ) : null}
                                        {selectedOfferDescription2 ===
                                        'Different Product Free' ? (
                                            <div className="top-twenty">
                                                {this.parentFreebieUI()}
                                                {this.productSearchUI(2)}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                {offerTitle ? (
                                    <div className="top-ten">
                                        <span style={{ fontWeight: '600' }}>
                                            Offer title preview:
                                        </span>{' '}
                                        "{offerTitle}"
                                    </div>
                                ) : null}

                                <div className="top-ten row">
                                    <div className="col-xs-6">
                                        <div className="image-up-not">
                                            Upload Parent Front Image
                                        </div>
                                        {frontImage ? (
                                            <div>
                                                <img
                                                    src={frontImage}
                                                    alt="Product front"
                                                    style={{ maxWidth: '100%' }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <ImageUploader
                                                    url="inwarding/upload"
                                                    type="frontImage"
                                                    handleUploadResponse={(
                                                        resp,
                                                        type
                                                    ) => {
                                                        this.setState({
                                                            [type]: resp,
                                                        });
                                                        this.sendEvent(
                                                            'ON_ADD_FRONT_BACK_PHOTO',
                                                            {
                                                                front_image:
                                                                    resp,
                                                            }
                                                        );
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-xs-6">
                                        <div className="image-up-not">
                                            Upload Parent Back Image
                                        </div>
                                        {backImage ? (
                                            <div>
                                                <img
                                                    src={backImage}
                                                    alt="Product front"
                                                    style={{ maxWidth: '100%' }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <ImageUploader
                                                    url="inwarding/upload"
                                                    type="backImage"
                                                    handleUploadResponse={(
                                                        resp,
                                                        type
                                                    ) => {
                                                        this.setState({
                                                            [type]: resp,
                                                        });
                                                        this.sendEvent(
                                                            'ON_ADD_FRONT_BACK_PHOTO',
                                                            { back_image: resp }
                                                        );
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
                {this.isNewListingValidated2() ? (
                    <div
                        className="bottom-btn"
                        style={{ left: '0', right: '0' }}
                    >
                        <button
                            className="btn btn-big-fin"
                            onClick={this.createNewListing2}
                        >
                            Create New Listing
                        </button>
                    </div>
                ) : null}
            </div>
        );
    };

    render() {
        const {
            selectedProduct,
            selectedListing,
            showOtherOptions,
            showNewListingBox,
            showAddedToPalletBox,
            excessQuantityPresent,
            excessInwardReason,
            actionAfterVendorSuppliedMore,
            manufacturerBatchNumber,
            inwardDetail,
            damageReasonType,
        } = this.state;

        const isBad = damageReasonType === 'damaged_reason_2';
        const { goodQty, badQty } = this.getGoodAndBadQuantity();
        let extraQuantity = 0;
        if (goodQty > this.state.underProcessQty) {
            if (!isBad) {
                extraQuantity = Math.abs(this.state.underProcessQty - goodQty);
            } else {
                extraQuantity =
                    Math.abs(this.state.underProcessQty - goodQty) + badQty;
            }
        }
        return (
            <div>
                <div className="visible-xs visible-sm">
                    {this.getHeaderBox()}
                </div>
                {!selectedListing && !showOtherOptions ? (
                    <div>
                        <div style={{ padding: '10px' }}>
                            <ListingProductTest
                                product={selectedProduct}
                                showQty={false}
                            />
                        </div>
                        <div className="btm-actn-br">
                            <div
                                style={{
                                    textAlign: 'center',
                                    marginBottom: '20px',
                                    fontWeight: 'bold',
                                }}
                                className="v-imp-txt"
                            >
                                Verify MRP & Offer Details
                            </div>
                            <div className="row">
                                <div className="col-xs-6">
                                    <button
                                        className="btn btn-big-red"
                                        onClick={() => {
                                            this.getAllListingsForJPIN();
                                            this.yesOrNoClicked('no');
                                        }}
                                    >
                                        No, It’s not same
                                    </button>
                                </div>
                                <div className="col-xs-6">
                                    <button
                                        className="btn btn-big-green"
                                        onClick={() => {
                                            this.productConfirmed();
                                            this.yesOrNoClicked('yes');
                                        }}
                                    >
                                        Yes, It is
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        {!showNewListingBox ? (
                            <div>
                                <div id="allData"></div>
                                {selectedListing ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {this.showEnterInwardingDetails2()}
                                    </div>
                                ) : (
                                    <div>{this.showOtherListingsOptions()}</div>
                                )}
                            </div>
                        ) : null}
                    </div>
                )}
                <div>
                    {showNewListingBox ? (
                        <div>{this.createNewListingFlow2()}</div>
                    ) : null}
                </div>
                {this.state.error ? (
                    <ErrorBox
                        errorText={this.state.error}
                        closeError={this.closeError}
                    />
                ) : null}
                {this.state.loading ? <MobLoader /> : null}
                <Dialog
                    open={showAddedToPalletBox}
                    fullWidth={true}
                    onClose={this.closeAddedToPalletBox}
                >
                    <div
                        style={{
                            fontSize: '18px',
                            textAlign: 'center',
                            padding: '10px',
                        }}
                    >
                        <div
                            className="text-right"
                            onClick={this.closeAddedToPalletBox}
                        >
                            <img
                                src={close}
                                style={{ height: '22px', width: '22px' }}
                                alt="x"
                            />
                        </div>
                        <div className="top-thirty">
                            <img
                                src={filled_tick}
                                alt="success-img"
                                className="top-thirty"
                                style={{ height: '60' }}
                            />
                        </div>
                        <div className="top-thirty">
                            <div className="top-thirty">
                                Product Added To Pallet Successfully
                            </div>
                        </div>
                        <div className="top-thirty">
                            <div className="top-twenty"></div>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    open={excessQuantityPresent}
                    maxWidth="lg"
                    fullWidth={true}
                    onClose={() =>
                        this.setState({
                            excessQuantityPresent: false,
                            excessInwardReason: '',
                            actionAfterVendorSuppliedMore: '',
                        })
                    }
                    classes={{ paper: 'tw-margn-class' }}
                >
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            <img
                                src={warn}
                                alt="success-img"
                                style={{ height: '30px', marginRight: '10px' }}
                            />
                            <div style={{ textAlign: 'left' }}>
                                <p>
                                    Quantity entered is more than the PO
                                    Quantity.
                                </p>
                                <p>PO Quantity: {this.state.underProcessQty}</p>
                                <p>Good Quantity Entered: {goodQty} </p>
                                <p>
                                    Bad Quantity Entered: {isBad ? badQty : 0}{' '}
                                </p>
                                <p>
                                    RTV Quantity Entered: {!isBad ? badQty : 0}{' '}
                                </p>
                                <p>
                                    Extra Quantity: {extraQuantity}
                                    {/*{isBad
                                        ? Math.abs(
                                              this.state.underProcessQty -
                                                  goodQty -
                                                  badQty
                                          )
                                        : Math.abs(
                                              this.state.underProcessQty -
                                                  goodQty +
                                                  badQty
                                          )}{' '}*/}
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                borderBottom: '2px solid #dfdfdf',
                                marginTop: '10px',
                            }}
                        ></div>

                        {/*<div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '20px 10px 10px 10px',
                            }}
                        >*/}
                        {/*<input
                                type='radio'
                                name='excessInwardReason'
                                id='excessInwardOption1'
                                value={'vendor_supplied_more_qty'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor='excessInwardOption1'
                                style={{ textAlign: 'left' }}
                            >
                                Vendor supplied more quantity
                            </label>*/}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                name="excessInwardReason"
                                id="actionAfterVendorSuppliedMoreOption2"
                                //name='actionAfterVendorSuppliedMore'
                                //id='actionAfterVendorSuppliedMoreOption2'
                                value={'rtv_now'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="actionAfterVendorSuppliedMoreOption2"
                                style={{ textAlign: 'left' }}
                            >
                                I will RTV now
                            </label>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                //name='actionAfterVendorSuppliedMore'
                                name="excessInwardReason"
                                id="actionAfterVendorSuppliedMoreOption1"
                                value={'rtv_later'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="actionAfterVendorSuppliedMoreOption1"
                                style={{ textAlign: 'left' }}
                            >
                                I will RTV later
                            </label>
                        </div>
                        {excessInwardReason === 'rtv_later' ? (
                            <div>
                                <InputFloating
                                    type="text"
                                    label="Manufacturer Batch Number"
                                    name="manufacturerBatchNumber"
                                    value={manufacturerBatchNumber}
                                    onChange={this.setNameToValue}
                                />
                            </div>
                        ) : null}
                        {/*</div>*/}

                        {/*{excessInwardReason === 'vendor_supplied_more_qty' ? (
                            <div style={{ margin: '10px 20px 5px 20px' }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        margin: '10px',
                                    }}
                                >
                                    <input
                                        type='radio'
                                        name='actionAfterVendorSuppliedMore'
                                        id='actionAfterVendorSuppliedMoreOption1'
                                        value={'rtv_later'}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    />
                                    <label
                                        htmlFor='actionAfterVendorSuppliedMoreOption1'
                                        style={{ textAlign: 'left' }}
                                    >
                                        I will RTV later
                                    </label>
                                </div>
                                {actionAfterVendorSuppliedMore ===
                                'rtv_later' ? (
                                    <div>
                                        <InputFloating
                                            type='text'
                                            label='Manufacturer Batch Number'
                                            name='manufacturerBatchNumber'
                                            value={manufacturerBatchNumber}
                                            onChange={this.setNameToValue}
                                        />
                                    </div>
                                ) : null}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        margin: '10px',
                                    }}
                                >
                                    <input
                                        type='radio'
                                        name='actionAfterVendorSuppliedMore'
                                        id='actionAfterVendorSuppliedMoreOption2'
                                        value={'rtv_now'}
                                        onChange={(e) => {
                                            this.setNameToValue(e);
                                        }}
                                        style={{ marginRight: '5px' }}
                                    />
                                    <label
                                        htmlFor='actionAfterVendorSuppliedMoreOption2'
                                        style={{ textAlign: 'left' }}
                                    >
                                        I will RTV now
                                    </label>
                                </div>
                            </div>
                        ) : null}*/}

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                margin: '10px',
                            }}
                        >
                            <input
                                type="radio"
                                name="excessInwardReason"
                                id="excessInwardOption2"
                                value={'edit'}
                                onChange={(e) => {
                                    this.setNameToValue(e);
                                }}
                                style={{ marginRight: '5px' }}
                            />
                            <label
                                htmlFor="excessInwardOption2"
                                style={{ textAlign: 'left' }}
                            >
                                I want to edit the quantity
                            </label>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                marginTop: '80px',
                            }}
                        >
                            {/* <button className="btn" onClick={() => this.setState({ excessQuantityPresent: false, excessInwardReason: '', actionAfterVendorSuppliedMore: '' })}>Edit Quantity</button> */}
                            <button
                                disabled={!this.validateProceed()}
                                className="btn btn-jt-green"
                                onClick={this.proceedClicked}
                            >
                                Proceed
                            </button>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/ProductDetailsTest.js